import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    line-height: var(--line-height-normal);
  }

  strong {
    font-weight: var(--font-weight-semibold);
  }

  h1,
  h2,
  h3,
  h4 {
    margin: var(--size-2) 0 var(--size-2) 0;
    line-height: var(--line-height-snug);
  }

  h1 {
    font-size: var(--font-size-2xl);
    font-weight: var(--font-weight-normal);
    margin-top: 0px;
  }

  h2 {
    font-size: var(--font-size-lg);
  }

  h3 {
    font-size: var(--font-size-md);
  }

  h4 {
    font-size: var(--font-size-xs);
    text-transform: uppercase;
  }

  p {
    margin: var(--size-2) 0;
  }

  a {
    color: var(--color-black);
  }

  ul {
    padding: 0 0 0 var(--size-3);
    margin: var(--size-2) 0;
  }

  ol {
    padding: 0 0 0 var(--size-3);
    margin: var(--size-2) 0;
  }

  ol ::marker {
    font-weight: var(--font-weight-semibold);
  }

  li {
    margin: 0;
  }

  ul li span {
    margin-left: 1px;
  }

  ol li span {
    margin-left: 0px;
  }

  ul ul,
  ol ol,
  ol li ul,
  ul li ol {
    margin: 0;
  }

  blockquote {
    box-shadow: inset var(--size-1) 0 0 -5px currentColor;
    padding: 0 0 0 var(--size-2);
    margin: 0 0 0 var(--size-1);
  }

  bp-cite {
    --bp-cite-color: var(--color-black);
  }

  bp-spinner {
    margin-top: var(--size-1);
    margin-bottom: var(--size-1);
    margin-left: 50%;
    transform: translate(-50%);
  }
`;
